export default __webpack_public_path__ + "static/media/segments-image_mobile.7da473de.png";